import {useBreakpoint as $367536236d783ddf$export$199d6754bdf4e1e3} from "./BreakpointProvider.mjs";
import {useLocale as $i4JHJ$useLocale} from "react-aria/I18nProvider";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

const $63d03c54ca5e4b88$export$fe9c6e915565b4e8 = {
    margin: [
        'margin',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    marginStart: [
        $63d03c54ca5e4b88$var$rtl('marginLeft', 'marginRight'),
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    marginEnd: [
        $63d03c54ca5e4b88$var$rtl('marginRight', 'marginLeft'),
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    // marginLeft: ['marginLeft', dimensionValue],
    // marginRight: ['marginRight', dimensionValue],
    marginTop: [
        'marginTop',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    marginBottom: [
        'marginBottom',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    marginX: [
        [
            'marginLeft',
            'marginRight'
        ],
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    marginY: [
        [
            'marginTop',
            'marginBottom'
        ],
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    width: [
        'width',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    height: [
        'height',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    minWidth: [
        'minWidth',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    minHeight: [
        'minHeight',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    maxWidth: [
        'maxWidth',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    maxHeight: [
        'maxHeight',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    isHidden: [
        'display',
        $63d03c54ca5e4b88$var$hiddenValue
    ],
    alignSelf: [
        'alignSelf',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ],
    justifySelf: [
        'justifySelf',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ],
    position: [
        'position',
        $63d03c54ca5e4b88$var$anyValue
    ],
    zIndex: [
        'zIndex',
        $63d03c54ca5e4b88$var$anyValue
    ],
    top: [
        'top',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    bottom: [
        'bottom',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    start: [
        $63d03c54ca5e4b88$var$rtl('left', 'right'),
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    end: [
        $63d03c54ca5e4b88$var$rtl('right', 'left'),
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    left: [
        'left',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    right: [
        'right',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    order: [
        'order',
        $63d03c54ca5e4b88$var$anyValue
    ],
    flex: [
        'flex',
        $63d03c54ca5e4b88$var$flexValue
    ],
    flexGrow: [
        'flexGrow',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ],
    flexShrink: [
        'flexShrink',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ],
    flexBasis: [
        'flexBasis',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ],
    gridArea: [
        'gridArea',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ],
    gridColumn: [
        'gridColumn',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ],
    gridColumnEnd: [
        'gridColumnEnd',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ],
    gridColumnStart: [
        'gridColumnStart',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ],
    gridRow: [
        'gridRow',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ],
    gridRowEnd: [
        'gridRowEnd',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ],
    gridRowStart: [
        'gridRowStart',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ]
};
const $63d03c54ca5e4b88$export$e0705d1a55f297c = {
    ...$63d03c54ca5e4b88$export$fe9c6e915565b4e8,
    backgroundColor: [
        'backgroundColor',
        $63d03c54ca5e4b88$var$backgroundColorValue
    ],
    borderWidth: [
        'borderWidth',
        $63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderStartWidth: [
        $63d03c54ca5e4b88$var$rtl('borderLeftWidth', 'borderRightWidth'),
        $63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderEndWidth: [
        $63d03c54ca5e4b88$var$rtl('borderRightWidth', 'borderLeftWidth'),
        $63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderLeftWidth: [
        'borderLeftWidth',
        $63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderRightWidth: [
        'borderRightWidth',
        $63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderTopWidth: [
        'borderTopWidth',
        $63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderBottomWidth: [
        'borderBottomWidth',
        $63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderXWidth: [
        [
            'borderLeftWidth',
            'borderRightWidth'
        ],
        $63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderYWidth: [
        [
            'borderTopWidth',
            'borderBottomWidth'
        ],
        $63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderColor: [
        'borderColor',
        $63d03c54ca5e4b88$var$borderColorValue
    ],
    borderStartColor: [
        $63d03c54ca5e4b88$var$rtl('borderLeftColor', 'borderRightColor'),
        $63d03c54ca5e4b88$var$borderColorValue
    ],
    borderEndColor: [
        $63d03c54ca5e4b88$var$rtl('borderRightColor', 'borderLeftColor'),
        $63d03c54ca5e4b88$var$borderColorValue
    ],
    borderLeftColor: [
        'borderLeftColor',
        $63d03c54ca5e4b88$var$borderColorValue
    ],
    borderRightColor: [
        'borderRightColor',
        $63d03c54ca5e4b88$var$borderColorValue
    ],
    borderTopColor: [
        'borderTopColor',
        $63d03c54ca5e4b88$var$borderColorValue
    ],
    borderBottomColor: [
        'borderBottomColor',
        $63d03c54ca5e4b88$var$borderColorValue
    ],
    borderXColor: [
        [
            'borderLeftColor',
            'borderRightColor'
        ],
        $63d03c54ca5e4b88$var$borderColorValue
    ],
    borderYColor: [
        [
            'borderTopColor',
            'borderBottomColor'
        ],
        $63d03c54ca5e4b88$var$borderColorValue
    ],
    borderRadius: [
        'borderRadius',
        $63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderTopStartRadius: [
        $63d03c54ca5e4b88$var$rtl('borderTopLeftRadius', 'borderTopRightRadius'),
        $63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderTopEndRadius: [
        $63d03c54ca5e4b88$var$rtl('borderTopRightRadius', 'borderTopLeftRadius'),
        $63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderBottomStartRadius: [
        $63d03c54ca5e4b88$var$rtl('borderBottomLeftRadius', 'borderBottomRightRadius'),
        $63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderBottomEndRadius: [
        $63d03c54ca5e4b88$var$rtl('borderBottomRightRadius', 'borderBottomLeftRadius'),
        $63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderTopLeftRadius: [
        'borderTopLeftRadius',
        $63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderTopRightRadius: [
        'borderTopRightRadius',
        $63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderBottomLeftRadius: [
        'borderBottomLeftRadius',
        $63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderBottomRightRadius: [
        'borderBottomRightRadius',
        $63d03c54ca5e4b88$var$borderRadiusValue
    ],
    padding: [
        'padding',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    paddingStart: [
        $63d03c54ca5e4b88$var$rtl('paddingLeft', 'paddingRight'),
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    paddingEnd: [
        $63d03c54ca5e4b88$var$rtl('paddingRight', 'paddingLeft'),
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    paddingLeft: [
        'paddingLeft',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    paddingRight: [
        'paddingRight',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    paddingTop: [
        'paddingTop',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    paddingBottom: [
        'paddingBottom',
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    paddingX: [
        [
            'paddingLeft',
            'paddingRight'
        ],
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    paddingY: [
        [
            'paddingTop',
            'paddingBottom'
        ],
        $63d03c54ca5e4b88$export$abc24f5b99744ea6
    ],
    overflow: [
        'overflow',
        $63d03c54ca5e4b88$export$46b6c81d11d2c30a
    ]
};
const $63d03c54ca5e4b88$var$borderStyleProps = {
    borderWidth: 'borderStyle',
    borderLeftWidth: 'borderLeftStyle',
    borderRightWidth: 'borderRightStyle',
    borderTopWidth: 'borderTopStyle',
    borderBottomWidth: 'borderBottomStyle'
};
function $63d03c54ca5e4b88$var$rtl(ltr, rtl) {
    return (direction)=>direction === 'rtl' ? rtl : ltr;
}
const $63d03c54ca5e4b88$var$UNIT_RE = /(%|px|em|rem|vw|vh|auto|cm|mm|in|pt|pc|ex|ch|rem|vmin|vmax|fr)$/;
const $63d03c54ca5e4b88$var$FUNC_RE = /^\s*\w+\(/;
const $63d03c54ca5e4b88$var$SPECTRUM_VARIABLE_RE = /(static-)?size-\d+|single-line-(height|width)/g;
function $63d03c54ca5e4b88$export$abc24f5b99744ea6(value) {
    if (typeof value === 'number') return value + 'px';
    if (!value) return undefined;
    if ($63d03c54ca5e4b88$var$UNIT_RE.test(value)) return value;
    if ($63d03c54ca5e4b88$var$FUNC_RE.test(value)) return value.replace($63d03c54ca5e4b88$var$SPECTRUM_VARIABLE_RE, 'var(--spectrum-global-dimension-$&, var(--spectrum-alias-$&))');
    return `var(--spectrum-global-dimension-${value}, var(--spectrum-alias-${value}))`;
}
function $63d03c54ca5e4b88$export$f348bec194f2e6b5(value, matchedBreakpoints) {
    let responsiveValue = $63d03c54ca5e4b88$export$52dbfdbe1b2c3541(value, matchedBreakpoints);
    if (responsiveValue != null) return $63d03c54ca5e4b88$export$abc24f5b99744ea6(responsiveValue);
}
function $63d03c54ca5e4b88$var$colorValue(value, type = 'default', version = 5) {
    if (version > 5) return `var(--spectrum-${value}, var(--spectrum-semantic-${value}-color-${type}))`;
    return `var(--spectrum-legacy-color-${value}, var(--spectrum-global-color-${value}, var(--spectrum-semantic-${value}-color-${type})))`;
}
function $63d03c54ca5e4b88$var$backgroundColorValue(value, version = 5) {
    if (!value) return undefined;
    return `var(--spectrum-alias-background-color-${value}, ${$63d03c54ca5e4b88$var$colorValue(value, 'background', version)})`;
}
function $63d03c54ca5e4b88$var$borderColorValue(value, version = 5) {
    if (!value) return undefined;
    if (value === 'default') return 'var(--spectrum-alias-border-color)';
    return `var(--spectrum-alias-border-color-${value}, ${$63d03c54ca5e4b88$var$colorValue(value, 'border', version)})`;
}
function $63d03c54ca5e4b88$var$borderSizeValue(value) {
    return value && value !== 'none' ? `var(--spectrum-alias-border-size-${value})` : '0';
}
function $63d03c54ca5e4b88$var$borderRadiusValue(value) {
    if (!value) return undefined;
    return `var(--spectrum-alias-border-radius-${value})`;
}
function $63d03c54ca5e4b88$var$hiddenValue(value) {
    return value ? 'none' : undefined;
}
function $63d03c54ca5e4b88$var$anyValue(value) {
    return value;
}
function $63d03c54ca5e4b88$var$flexValue(value) {
    if (typeof value === 'boolean') return value ? '1' : undefined;
    return '' + value;
}
function $63d03c54ca5e4b88$export$f3c39bb9534218d0(props, handlers, direction, matchedBreakpoints) {
    let style = {};
    for(let key in props){
        let styleProp = handlers[key];
        if (!styleProp || props[key] == null) continue;
        let [name, convert] = styleProp;
        if (typeof name === 'function') name = name(direction);
        let prop = $63d03c54ca5e4b88$export$52dbfdbe1b2c3541(props[key], matchedBreakpoints);
        let value = convert(prop, props.colorVersion);
        if (Array.isArray(name)) for (let k of name)style[k] = value;
        else style[name] = value;
    }
    for(let prop in $63d03c54ca5e4b88$var$borderStyleProps)if (style[prop]) {
        style[$63d03c54ca5e4b88$var$borderStyleProps[prop]] = 'solid';
        style.boxSizing = 'border-box';
    }
    return style;
}
function $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41(props, handlers = $63d03c54ca5e4b88$export$fe9c6e915565b4e8, options = {}) {
    let { UNSAFE_className: UNSAFE_className, UNSAFE_style: UNSAFE_style, ...otherProps } = props;
    let breakpointProvider = (0, $367536236d783ddf$export$199d6754bdf4e1e3)();
    let { direction: direction } = (0, $i4JHJ$useLocale)();
    let { matchedBreakpoints: matchedBreakpoints = breakpointProvider?.matchedBreakpoints || [
        'base'
    ] } = options;
    let styles = $63d03c54ca5e4b88$export$f3c39bb9534218d0(props, handlers, direction, matchedBreakpoints);
    let style = {
        ...UNSAFE_style,
        ...styles
    };
    // @ts-ignore
    if (otherProps.className && process.env.NODE_ENV !== 'production') console.warn("The className prop is unsafe and is unsupported in React Spectrum v3. Please use style props with Spectrum variables, or UNSAFE_className if you absolutely must do something custom. Note that this may break in future versions due to DOM structure changes.");
    // @ts-ignore
    if (otherProps.style && process.env.NODE_ENV !== 'production') console.warn("The style prop is unsafe and is unsupported in React Spectrum v3. Please use style props with Spectrum variables, or UNSAFE_style if you absolutely must do something custom. Note that this may break in future versions due to DOM structure changes.");
    let styleProps = {
        style: style,
        className: UNSAFE_className
    };
    if ($63d03c54ca5e4b88$export$52dbfdbe1b2c3541(props.isHidden, matchedBreakpoints)) styleProps.hidden = true;
    return {
        styleProps: styleProps
    };
}
function $63d03c54ca5e4b88$export$46b6c81d11d2c30a(value) {
    return value;
}
function $63d03c54ca5e4b88$export$52dbfdbe1b2c3541(prop, matchedBreakpoints) {
    if (prop && typeof prop === 'object' && !Array.isArray(prop)) {
        for(let i = 0; i < matchedBreakpoints.length; i++){
            let breakpoint = matchedBreakpoints[i];
            if (prop[breakpoint] != null) return prop[breakpoint];
        }
        return prop.base;
    }
    return prop;
}


export {$63d03c54ca5e4b88$export$fe9c6e915565b4e8 as baseStyleProps, $63d03c54ca5e4b88$export$abc24f5b99744ea6 as dimensionValue, $63d03c54ca5e4b88$export$46b6c81d11d2c30a as passthroughStyle, $63d03c54ca5e4b88$export$e0705d1a55f297c as viewStyleProps, $63d03c54ca5e4b88$export$f348bec194f2e6b5 as responsiveDimensionValue, $63d03c54ca5e4b88$export$52dbfdbe1b2c3541 as getResponsiveProp, $63d03c54ca5e4b88$export$f3c39bb9534218d0 as convertStyleProps, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41 as useStyleProps};
//# sourceMappingURL=styleProps.mjs.map
